import { useTranslation } from "react-i18next";

export const WithdrawlAccept = () => {
  const { t } = useTranslation();

  return (
    <main>
      <section className="container__standart">
        <h2
          style={{
            padding: "18.75rem 0rem 12.5rem 0rem",
            textAlign: "center",
          }}
        >
          {t("withdrawlAccept.title1")}
        </h2>
      </section>
    </main>
  );
};
